import React from 'react';

class ClientsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount = () => {
    }

    render() {
        return (
            <>
              client
            </>
        )
    }
}

export default ClientsList;

